<template>
    <form method="post" @submit.prevent="postForm">
        <div class="mb-3">
            <label class="mb-2" for="name">naam:</label>
            <input name="name" id="name" required class="block w-full px-3 py-3 border border-gray-400 rounded" v-model="formData.name"/>
        </div>
        <div class="mb-3">
            <label class="mb-2" for="company">organisatie:</label>
            <input name="company" id="company" class="block w-full px-3 py-3 border border-gray-400 rounded" v-model="formData.company"/>
        </div>
        <div class="mb-3">
            <label class="mb-2" for="phone">telefoon:</label>
            <input name="phone" id="phone" class="block w-full px-3 py-3 border border-gray-400 rounded" v-model="formData.phone"/>
        </div>
        <div class="mb-3">
            <label class="mb-2" for="email">emailadres:</label>
            <input
                name="email"
                id="email"
                type="email"
                required
                class="block w-full px-3 py-3 border border-gray-400 rounded"
                v-model="formData.email"
            />
        </div>
        <div class="mb-3">
            <label class="mb-2" for="challenge">uw vraag of uitdaging:</label>
            <textarea
                name="challenge"
                id="challenge"
                class="block w-full px-3 py-3 border border-gray-400 rounded h-24"
                placeholder="wat kunnen we voor u betekenen?"
                v-model="formData.challenge"
            ></textarea>
        </div>
        <div class="flex justify-end">
            <button class="flex items-center space-x-2 group py-1 px-2">
                <span>afspraak maken</span>
                <svg
                    class="stroke-current duration-100 group-hover:text-blue-700 group-focus:text-blue-700 text-gray-200 h-4 mx-auto"
                    viewBox="0 0 70 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        y="15"
                        width="63"
                        height="6"
                        fill="#9BC8DF"
                        stroke-width="0"
                        class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 duration-100"
                    />
                    <path
                        d="M12.5 15H66L53 2"
                        stroke-width="3"
                    />
                </svg>

            </button>
        </div>
    </form>
</template>

<script>
export default {
    name: "ContactForm",
    data: function(){
        return {
            formData: {
                name: '',
                email: '',
                phone: '',
                challenge: '',
                company: ''
            }
        };
    },
    methods: {
        postForm(){
            axios.post('/contact',this.formData);

            console.log('a');
        }
    }
};
</script>

<style scoped>

</style>
